import { ServiceUtil as serviceUtil } from './services.util'


export const AccountAPI = {
    sendMfaCodeToUser, 
    sendMfaCodeToUserEmail, 
    sendMfaCodeToUserText, 
    validateMfaCode, 
    changeUserPassword,
    sendMfaCodeToText, 
    sendMfaCodeToUserHash,
    resetUserPassword,
    validateMfaCodeAnon,
    sendAuthorizeDeviceMfa, 
    //Constants. 
    MFA_REASON_AUTHORIZE_DEVICE : 0, 
    MFA_REASON_AUTHORIZE_OPERATION : 1, 
    MFA_REASON_VALIDATE_USER : 2, 
    MFA_REASON_RESET_PASSWORD : 3, 
    MFA_REASON_EDIT_PROFILE : 4, 
    MFA_TARGET_EMAIL: 'TargetEmail', 
    MFA_TARGET_TEXT: 'TargetTextMessage'
}

//Sends MFA to the currently logged in user's email address. 
function sendMfaCodeToUserEmail(mfaReason, language){
    const mfaRequest = {
        issueReason: mfaReason, 
        deliveryMethod: AccountAPI.MFA_TARGET_EMAIL,
        targetLanguage: language
    }
    return sendMfaCodeToUser(mfaRequest);
}

function sendAuthorizeDeviceMfa(userEmail, deliveryMethod, language){
    const mfaRequest = {
        issueReason : 0, 
        deliveryMethod : deliveryMethod, 
        emailAddress: userEmail,
        targetLanguage: language
    }
    return serviceUtil.executeServiceCall("AccountAPI", 
        "Mfa/SendAuthDeviceMfaCode", 
        serviceUtil.postRequest(mfaRequest));
}
//Sends MFA to the currently logged in user's text 
function sendMfaCodeToUserText(mfaReason){
    const mfaRequest = {
        issueReason: mfaReason, 
        deliveryMethod : AccountAPI.MFA_TARGET_TEXT
    }
    return sendMfaCodeToUser(mfaRequest);
}

function sendMfaCodeToText(mfaReason, mobileNumber){
    const mfaRequest = {
        issueReason: mfaReason, 
        deliveryMethod : AccountAPI.MFA_TARGET_TEXT, 
        targetAddress : mobileNumber 
    }
    return sendMfaCode(mfaRequest);
}


function sendMfaCode(mfaRequest){
    return serviceUtil.executeServiceCall("AccountAPI", 
        "Mfa/SendMfaCode", serviceUtil.postRequest(mfaRequest));
}

//Sends MFA code to the currently logged on user. 
function sendMfaCodeToUser(mfaRequest) {
    return serviceUtil.executeServiceCall("AccountAPI", 
        "Mfa/SendMfaCodeToUser", serviceUtil.postRequest(mfaRequest));
}

function sendMfaCodeToUserHash(ssn, dob, target){
    var mfaRequest = {
        ssn: ssn, 
        Dob: dob, 
        issueReason : AccountAPI.MFA_REASON_RESET_PASSWORD, 
        deliveryMethod: target
    }
    return serviceUtil.executeServiceCall("AccountAPI", "Mfa/SendMfaCodeToUserHash", serviceUtil.postRequest(mfaRequest));
}


//Sends MFA code to the server for validation. 
function validateMfaCode(tokenId, mfaCode, mfaReason){
    var mfaValidationRequest = {
        tokenId : tokenId, 
        codeParts : mfaCode, 
        reason : mfaReason
    }
    return serviceUtil.executeServiceCall("AccountAPI", "Mfa/ValidateMfaCode", 
        serviceUtil.postRequest(mfaValidationRequest));
}

//Sends MFA code to the server for validation. 
function validateMfaCodeAnon(tokenId, mfaCode, mfaReason){
    var mfaValidationRequest = {
        tokenId : tokenId, 
        codeParts : mfaCode, 
        reason : mfaReason
    }
    return serviceUtil.executeServiceCall("AccountAPI", "Mfa/ValidateMfaCodeForUnregistered", 
        serviceUtil.postRequest(mfaValidationRequest));
}


function changeUserPassword(oldPassword, newPassword, mfaTokenId){
    var changePasswordRequest = {
        tokenId: mfaTokenId, 
        oldPassword : oldPassword, 
        newPassword : newPassword
    }
    return serviceUtil.executeServiceCall("AccountAPI", "Account/ChangeUserPassword", serviceUtil.postRequest(changePasswordRequest));
}

function resetUserPassword(tokenId, newPassword){
    var resetPasswordRequest = {
        tokenId: tokenId, 
        password : newPassword
    };
    return serviceUtil.executeServiceCall("AccountAPI", "Account/ForgotPassword", serviceUtil.postRequest(resetPasswordRequest));
}



// WEBPACK FOOTER //
// ./src/_services/account.service.js